<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M5.71,5.71C5.71,5.71,7.71,3.71,7.71,3.71C7.89,3.53,8,3.28,8,3C8,2.72,7.89,2.47,7.71,2.29C7.71,2.29,5.71,0.29,5.71,0.29C5.53,0.11,5.28,0,5,0C4.45,0,4,0.45,4,1C4,1.28,4.11,1.53,4.29,1.71C4.29,1.71,4.59,2,4.59,2C4.59,2,3,2,3,2C1.34,2,0,3.34,0,5C0,5,0,8,0,8C0,8.55,0.45,9,1,9C1.55,9,2,8.55,2,8C2,8,2,5,2,5C2,4.45,2.45,4,3,4C3,4,4.59,4,4.59,4C4.59,4,4.29,4.29,4.29,4.29C4.11,4.47,4,4.72,4,5C4,5.55,4.45,6,5,6C5.28,6,5.53,5.89,5.71,5.71C5.71,5.71,5.71,5.71,5.71,5.71ZM12.5,11C12.78,11,13,10.78,13,10.5C13,10.22,12.78,10,12.5,10C12.22,10,12,10.22,12,10.5C12,10.78,12.22,11,12.5,11C12.5,11,12.5,11,12.5,11ZM15,7C15,7,6,7,6,7C5.45,7,5,7.45,5,8C5,8,5,15,5,15C5,15.55,5.45,16,6,16C6,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,8,16,8C16,7.45,15.55,7,15,7C15,7,15,7,15,7ZM14,13.33C14,13.33,12,12,12,12C12,12,11,13,11,13C11,13,9,10,9,10C9,10,7,12.67,7,12.67C7,12.67,7,9,7,9C7,9,14,9,14,9C14,9,14,13.33,14,13.33C14,13.33,14,13.33,14,13.33Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ImageRotateRight',
} as DefineComponent
</script>
